import { FC, ReactNode } from 'react';

import { Box, StyleProps } from '@bonusly/design-system';

interface Props extends StyleProps {
	children: ReactNode;
}

export const SpeechBubble: FC<Props> = (props: Props) => (
	<Box background="bg.surface" borderRadius="md" boxShadow="sm" minWidth={0} overflow="hidden" {...props} />
);
